/*
 * TEMPORARY CHANGE — "Hora Início" and "Hora Fim" options when NO service is selected.
 *
 * What it does:
 * - With no service selected, "Hora Início" and "Hora Fim" offer times every 5 minutes
 *   (09:00, 09:05, ... 21:55) instead of every 15.
 * - Sessions WITH a service are untouched (they keep their service-specific / default times).
 *
 * How to remove it:
 * 1. Delete this file.
 * 2. useSessionTimeOptions.ts: remove the import of `generateNoServiceTimeOptions`, delete the
 *    temporary `timeOptions` block and uncomment the original one above it.
 * 3. SessionForm.tsx: remove the import of `generateNoServiceTimeOptions`, delete the temporary
 *    `endDateTimeOptions` line and uncomment the original one above it.
 * 4. Search the codebase for "temporaryNoServiceTimeOptions" to confirm nothing is left.
 */
const OPENING_HOUR = 9;
const CLOSING_HOUR = 21;
const TIME_STEP_MINUTES = 5;

export const generateNoServiceTimeOptions = () => {
    const hoursCount = CLOSING_HOUR - OPENING_HOUR + 1;
    const stepsPerHour = 60 / TIME_STEP_MINUTES;
    const minuteSteps = Array.from({ length: stepsPerHour }, (_, i) =>
        (i * TIME_STEP_MINUTES).toString().padStart(2, "0"),
    );
    const options = Array.from({ length: hoursCount }, (_, i) => i + OPENING_HOUR).flatMap((hour) =>
        minuteSteps.map((minute) => `${hour.toString().padStart(2, "0")}:${minute}`),
    );
    return options;
};
